import { offset } from './util';
/**
 * Places the connection point at the edge end's anchor point.
 */
export const anchor = function (line, view, magnet, options) {
    return offset(line.end, line.start, options.offset);
};
//# sourceMappingURL=anchor.js.map